import Api from './api';
export function checkIfHairProfileExists(callback) {
  const userId = localStorage.getItem("user_id");
  fetch('/api/hair-profiles?user-id=' + userId, {
      method: 'GET',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-auth-token': Api.auth_tokenManager()
      }
  }).then((response) => {
      if (response.status >= 400 && response.status < 500) return;
      else return response.json();
  }).then(responseJson => {
      if (responseJson.length >= 1) localStorage.setItem("user_has_hair_profile", userId);
      else callback();
  }).catch(function(err) {
      console.log(err);
  });
}



// WEBPACK FOOTER //
// ./src/utils/hairUtils.js